import { render, staticRenderFns } from "./HandoverObjectDyw.vue?vue&type=template&id=995be944&scoped=true"
import script from "./HandoverObjectDyw.vue?vue&type=script&lang=js"
export * from "./HandoverObjectDyw.vue?vue&type=script&lang=js"
import style0 from "./HandoverObjectDyw.vue?vue&type=style&index=0&id=995be944&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "995be944",
  null
  
)

export default component.exports